import { render, staticRenderFns } from "./SjiElement.vue?vue&type=template&id=1e6e377e&scoped=true"
import script from "./SjiElement.vue?vue&type=script&lang=js"
export * from "./SjiElement.vue?vue&type=script&lang=js"
import style0 from "./SjiElement.vue?vue&type=style&index=0&id=1e6e377e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6e377e",
  null
  
)

export default component.exports